  <mat-card appearance="outlined" class = "condition-card">
  <mat-card-header class = "condition-card-header">
    <img mat-card-avatar
       [ngSrc]=condition.url
       alt="icon for {{condition.name}}"
       class = "condition-card-header-image" fill >
  </mat-card-header>
    <mat-card-content class = "condition-card-content">
      <mat-card-title>
      {{ condition.name}}
        </mat-card-title>
    </mat-card-content>
</mat-card>

